var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoldFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0189 11.2319C14.5864 10.5656 13.9482 10.1225 13.1051 9.90312V9.86062C13.552 9.64812 13.9276 9.41062 14.232 9.14812C14.537 8.9 14.7707 8.6375 14.9339 8.36125C15.2526 7.78 15.4051 7.17062 15.3907 6.5325C15.3907 5.285 15.0045 4.28187 14.232 3.52312C13.4664 2.77188 12.3214 2.38937 10.7976 2.375H4.20386V17.8775H11.3189C12.5382 17.8775 13.5551 17.47 14.3707 16.6544C15.1932 15.8744 15.6114 14.815 15.6251 13.4756C15.6251 12.6675 15.4232 11.9194 15.0189 11.2319ZM6.72511 4.46937H10.532C11.3895 4.48375 12.0207 4.6925 12.4245 5.09687C12.8357 5.52937 13.0414 6.0575 13.0414 6.68125C13.0414 7.305 12.8357 7.8225 12.4245 8.23375C12.0207 8.68 11.3895 8.90375 10.532 8.90375H6.72511V4.46937ZM12.6695 14.9431C12.2657 15.4037 11.6276 15.6412 10.7557 15.6556H6.72511V10.9987H10.7551C11.627 11.0125 12.2651 11.2431 12.6689 11.69C13.0726 12.1437 13.2751 12.6894 13.2751 13.3275C13.2751 13.9506 13.0732 14.4894 12.6695 14.9431Z",
    fill: "#FE815F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldFormat);
export default __webpack_public_path__ + "static/media/bold-format.7934ca5a7330edd8393440066adefc0d.svg";
export { ForwardRef as ReactComponent };